import { Component, Input, OnChanges , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ModalService } from '@core/services/modal/modal.service';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-program-schedule',
    templateUrl: './program-schedule.component.html',
    styleUrls: ['./program-schedule.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramScheduleComponent implements OnChanges {
    @Input() unformattedSchedule: any;
    formattedSchedule: any;
    faClock = faClock;
    constructor(
        public toolService: ToolService,
        private modalService: ModalService
    ) {}

    ngOnChanges() {
        if (this.unformattedSchedule) {
            this.formattedSchedule = this.toolService.formatSchedule(
                this.unformattedSchedule
            );
        }
    }

    openTimeZines = () => {
        this.modalService.programTimeZones().then((data: any) => {
            // console.log(data);
        });
    };
}
